<template>
    <div class="analytics-tab">
        <customModalSuggests :settings="customModalSuggests"></customModalSuggests>
        <!-- modal windows -->
        <pdfTypeSelectionDialog :settings="pdfTypeSelectionDialogSettings"></pdfTypeSelectionDialog>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <customModalSidebar :settings="customSidebarSettings"></customModalSidebar>
        <questionActionSidebar :settings="questionActionSidebarSettings"></questionActionSidebar>
        <welcomeModal :settings="welcomeModalSettings"></welcomeModal>
        <moreOptionsSidebar :settings="moreOptionsSidebarSettings"></moreOptionsSidebar>

        <div v-if="pageLoad">
            <div class="order-banner" :class="{active: !this.showOrderBanner}">
                <div class="order-banner__wrapper">
                    <div class="order-banner__text">
                        <div class="order-banner__title">
                            {{translate('own_OrderStickerFrom')}}
                        </div>
                        <div class="order-banner__subtitle">
                            {{translate('orderBannerSubtitle')}}
                        </div>
                    </div>
                    <div class="order-banner__image">
                        <img src="@/assets/images/order_banner_picture.png">
                    </div>
                    <div class="order-banner__btn" @click="getToOrderPage">
                        <div class="order-banner__btn-text">
                            {{translate('orderBannerBtn')}}
                        </div>
                    </div>
                    <div class="order-banner__cross" @click="closeOrderBanner">
                        <img src="@/assets/icons/order_banner_close.svg">
                    </div>
                </div>
            </div>
            <div class="owner-filter">
                <div class="owner-filter__bottom">
                    <div>
                        <div class="range" v-if="RenderClass == 'desktop'">
                            <div class="range-select__wrapper">
                                <div class="range-select">
                                    <div class="dropdown-range">
                                        <h6>{{translate('groupBy')}}:</h6>
                                        <b-dropdown
                                            :text="translate(showReportByChosen.tag)"
                                            no-caret>
                                            <b-dropdown-item v-for="item in showReportBy"
                                                             v-on:click="showReportByFilter(item.tag)"
                                                             :key="item.tag">
                                                <span>{{translate(item.tag)}}</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                                <div class="range-select">
                                    <div class="dropdown-range">
                                        <h6>{{translate('own_selectRange')}}:</h6>
                                        <b-dropdown :text="this.translate(analyticTimeFilter.name)" class="m-2" no-caret>
                                            <b-dropdown-item v-on:click="setActive('day')">
                                                <span>{{translate('own_today')}}</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item v-on:click="setActive('week')">
                                                <span>{{translate('own_last7days')}}</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item v-on:click="setActive('all')">
                                                <span>{{this.translate('own_allTime')}}</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item v-on:click="setActive('custom')">
                                                <span>{{this.translate('own_custom')}}...</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>

                                    <div class="dropdown-range" v-if="isVisibleDropdown">
                                        <h6>{{translate('site')}}:</h6>
                                        <b-dropdown
                                            :text="analyticSiteFilter.tag === 'all' ? translate(analyticSiteFilter.tag) : analyticSiteFilter.tag"
                                            class="m-2" no-caret>
                                            <b-dropdown-item v-on:click="chooseSite({tag:'all', uid: ''})">
                                                <span>{{translate('all')}}</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item v-for="(item, index) in siteListDropdown" :key="index"
                                                             v-on:click="chooseSite({tag: item.tag, uid: item.uid})">
                                                <span>{{item.tag}}</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                    <div class="dropdown-range">
                                        <h6>{{translate('Filter')}}</h6>
                                        <b-form-input
                                            v-model="searchFilter"
                                            :placeholder="translate('own_filter_placeholder')"
                                            class="search_places"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="calendar-inline__wrapper">
                                <div class="calendar-inline" v-if="analyticTimeFilter.attr == 'custom'">
                                    <div :class="'input ' + [customDate.date_from ? 'have-data' : ''] + [!showDateFrom ? ' hide-picker' : '']">
                                        <date-picker
                                            name="date"
                                            id="datefrom"
                                            v-model="dateFromModel"
                                            :config="optionsFrom"
                                            @dp-hide="doSomethingOnHide"
                                            @dp-change="doSomethingOnChangeFrom"
                                        ></date-picker>
                                        <label>{{translate('From')}}</label>
                                        <label @click="showDateFrom = !showDateFrom" class="btn" for="datefrom">
                                            <img src="@/assets/icons/ic_calendar-1.svg">
                                        </label>
                                    </div>
                                </div>
                                <div class="calendar-inline" v-if="analyticTimeFilter.attr == 'custom'">
                                    <div :class="'input ' + [customDate.date_to ? 'have-data' : ''] + [!showDateTo ? ' hide-picker' : '']">
                                        <date-picker
                                            name="date"
                                            id="dateto"
                                            v-model="dateToModel"
                                            :config="optionsTo"
                                            @dp-hide="doSomethingOnHide"
                                            @dp-change="doSomethingOnChangeTo"></date-picker>
                                        <label>{{translate('To')}}</label>
                                        <label @click="showDateTo = !showDateTo" class="btn" for="dateto">
                                            <img src="@/assets/icons/ic_calendar-1.svg">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="search" hidden v-if="false">
                            <input type="text" :placeholder="this.translate('own_Search') + '...'">
                            <button>
                                <img src="@/assets/images/ic_search@2x.png" alt="Search">
                            </button>
                        </div>
                        <div class="button-group analytic" v-if="siteListDropdown.length || places.length || items.length">
                            <div class="button-group__wrapper">
                                <div class="moreOption">
                                    <button class="primaryButton" @click="moreOptionBtnClick">
                                        {{translate('moreOptiosPopuoTitle')}}
                                    </button>
                                </div>
                                <div>
                                    <button
                                        v-if="needShowServiceLogsBtn()"
                                        class="primaryButton additional_service" @click="routeToServiceLogsDashboard">
                                            <span class="order-btn__text">{{translate('serviceLogs')}}</span>
                                    </button>
                                </div>
                                <div>
                                    <button
                                        v-if="airLeadCheck()"
                                        class="primaryButton additional_service" @click="routeToAirLeadDashboard">
                                            <span class="order-btn__text">{{translate('airLeads')}}</span>
                                    </button>
                                </div>
                                <button class="primaryButton" @click="modalAdd" v-if="hasEditPermission && this.items.length == 0">
                                    <img src="@/assets/icons/ic_+.svg">
                                    <span class="createQuestion__text">{{translate('own_createQuestion')}}</span>
                                </button>
                            </div>
                        </div>
                        <transition name="fade" appear class="filterMobile">
                            <div class="filter__wrapper" id="filter__wrapper">
                                <div class="range" v-if="RenderClass == 'mobile'">
                                    <div class="range-select__wrapper">
                                        <div class="range-select">
                                            <div class="dropdown-range">
                                                <h6>{{translate('groupBy')}}:</h6>
                                                <b-dropdown
                                                        :text="translate(showReportByChosen.tag)"
                                                        no-caret>
                                                    <b-dropdown-item v-for="item in showReportBy"
                                                                     v-on:click="showReportByFilter(item.tag)"
                                                                     :key="item.tag">
                                                        <span>{{translate(item.tag)}}</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                            <div class="dropdown-range">
                                                <h6>{{translate('own_selectRange')}}:</h6>
                                                <b-dropdown :text="this.translate(analyticTimeFilter.name)" class="m-2" no-caret>
                                                    <b-dropdown-item v-on:click="setActive('day')">
                                                        <span>{{translate('own_today')}}</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item v-on:click="setActive('week')">
                                                        <span>{{translate('own_last7days')}}</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item v-on:click="setActive('all')">
                                                        <span>{{this.translate('own_allTime')}}</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item v-on:click="setActive('custom')">
                                                        <span>{{this.translate('own_custom')}}...</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                        <div class="dropdown-range" v-if="isVisibleDropdown">
                                            <h6>{{translate('site')}}:</h6>
                                            <b-dropdown
                                                    :text="analyticSiteFilter.tag === 'all' ? translate(analyticSiteFilter.tag) : analyticSiteFilter.tag"
                                                    class="m-2" no-caret>
                                                <b-dropdown-item v-on:click="chooseSite({tag:'all', uid: ''})">
                                                    <span>{{translate('all')}}</span>
                                                </b-dropdown-item>
                                                <b-dropdown-item v-for="(item, index) in siteListDropdown" :key="index"
                                                                 v-on:click="chooseSite({tag: item.tag, uid: item.uid})">
                                                    <span>{{item.tag}}</span>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                        <div class="calendar-inline__wrapper">
                                            <div class="calendar-inline" v-if="analyticTimeFilter.attr == 'custom'">
                                                <div :class="'input ' + [customDate.date_from ? 'have-data' : ''] + [!showDateFrom ? ' hide-picker' : '']">
                                                    <date-picker
                                                            name="date"
                                                            id="datefromMobile"
                                                            v-model="dateFromModel"
                                                            :config="optionsFrom"
                                                            @dp-hide="doSomethingOnHide"
                                                            @dp-change="doSomethingOnChangeFrom"
                                                    ></date-picker>
                                                    <label>{{translate('From')}}</label>
                                                    <label @click="showDateFrom = !showDateFrom" class="btn" for="datefromMobile">
                                                        <img src="@/assets/icons/ic_calendar-1.svg">
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="calendar-inline" v-if="analyticTimeFilter.attr == 'custom'">
                                                <div :class="'input ' + [customDate.date_to ? 'have-data' : ''] + [!showDateTo ? ' hide-picker' : '']">
                                                    <date-picker
                                                            name="date"
                                                            id="datetoMobile"
                                                            v-model="dateToModel"
                                                            :config="optionsTo"
                                                            @dp-hide="doSomethingOnHide"
                                                            @dp-change="doSomethingOnChangeTo"></date-picker>
                                                    <label>{{translate('To')}}</label>
                                                    <label @click="showDateTo = !showDateTo" class="btn" for="datetoMobile">
                                                        <img src="@/assets/icons/ic_calendar-1.svg">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="range-select">
                                            <div class="dropdown-range">
                                                <h6>{{translate('Filter')}}</h6>
                                                <b-form-input
                                                        v-model="searchFilter"
                                                        :placeholder="translate('own_filter_placeholder')"
                                                        class="search_places"
                                                ></b-form-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <div>
                        <!--          -->
                        <div class="question-list__bottom">
                            <div class="rates rates-total-count general" v-if="generalCount.isVisible && places.length">
                                <div class="rates-section total">
                                    <div>
                                        <span class="count">{{generalCount.happy + generalCount.ok + generalCount.sad}}</span>
                                        <span class="description">{{translate('own_Total')}}</span>
                                    </div>
                                </div>
                                <b-button class="rates-section popover-target"
                                          :id="`org-smile-happy`"
                                          @click="onShowPopover(`org-smile-happy`, { org: places })"
                                >
                                    <img src="@/assets/icons/smile.svg" alt="">
                                    <div>
                                        <span class="count">{{generalCount.happy}}</span>
                                        <span class="description">{{translate('own_Happy')}}</span>
                                    </div>
                                </b-button>
                                <b-button class="rates-section popover-target"
                                          :id="`org-smile-soso`"
                                          @click="onShowPopover(`org-smile-soso`, { org: places })"
                                >
                                    <img src="@/assets/icons/normal.svg" alt="">
                                    <div>
                                        <span class="count">{{generalCount.ok}}</span>
                                        <span class="description">{{translate('own_SoSo')}}</span>
                                    </div>
                                </b-button>
                                <b-button class="rates-section popover-target"
                                          :id="`org-smile-sad`"
                                          @click="onShowPopover(`org-smile-sad`, { org: places })"
                                >
                                    <img src="@/assets/icons/sad.svg" alt="">
                                    <div>
                                        <span class="count">{{generalCount.sad}}</span>
                                        <span class="description">{{translate('own_Sad')}}</span>
                                    </div>
                                </b-button>
                            </div>
                        </div>
                        <!--          -->

                        <!--    POPOVER      -->

                        <div class="text-center">
                            <div class="myPopover__wrapper">
                                <div class="myPopover popover chart-popover fade show bs-popover-bottom"
                                     v-show="showPopoverBool">
                                    <div class="arrow"></div>
                                    <div class="chart-panel-right">
                                    <span
                                            class="chart-undo-icon"
                                            v-if="latestChartZoom.navHistory.length > 0"
                                            @click="chartPrevStep"
                                    ></span>
                                        <span class="reset-chart-icon" @click="onResetChart"></span>
                                        <span class="chart-close-icon" @click="showPopoverBool = false"></span>
                                    </div>
                                    <amcharts
                                            :amchartsData="amchartsData"
                                            :closePopover="showPopoverBool"
                                            @onHitDate="onHitDate"></amcharts>
                                </div>
                            </div>
                        </div>

                        <!--    POPOVER      -->


                    </div>
                </div>
            </div>
            <div class="reports-table">
                <ul v-if="reportItems">
                    <li v-for="item in reportItems"
                        :key="item.title"
                        class="root-item">
                        <h3 @click="onMainListItemClick(item)" v-if="showReportByChosen.tag == 'by_sites'">
                            <i v-if="item.show" class="fas fa-caret-right"></i>
                            <i v-else class="fas fa-caret-down"></i>
                            <span v-if="siteListDropdown.length == 1">{{item.title}}</span>
                            <span v-else>{{item.title}} - {{item.short_tag}}</span>
                        </h3>
                        <h3 @click="onMainListItemClick(item)" v-else>
                            <i v-if="item.show" class="fas fa-caret-right"></i>
                            <i v-else class="fas fa-caret-down"></i>
                            {{item.title}}
                        </h3>
                        <div class="rates-section">
                            <ul>
                                <!--              <li>-->
                                <!--                <div class="rates-item">-->
                                <!--                  <div class="info">-->
                                <!--                    <span>Lorem</span>-->
                                <!--                    <b>999</b>-->
                                <!--                  </div>-->
                                <!--                </div>-->
                                <!--              </li>-->
                                <!--              <li>-->
                                <!--                <div class="rates-item">-->
                                <!--                  <div class="info">-->
                                <!--                    <span>Lorem</span>-->
                                <!--                    <b>999</b>-->
                                <!--                  </div>-->
                                <!--                </div>-->
                                <!--              </li>-->
                                <li>
                                    <div class="rates-group">
                                        <div class="rates-item pointer rates-section popover-target">
                                            <div class="rates-item__wrapper" @click="onShowPopover(`grouped_question-smile-happy`, { grouped_question: item })">
                                                <div class="rates-item__text">
                                                    {{translate('TotalVotes')}}
                                                </div>
                                                <div class="rates-item__count">
                                                    {{ item.total}}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="rates-item pointer rates-section popover-target"
                                            :id="`grouped_question-smile-happy-${item.questions[0].uid}`"
                                            @click="onShowPopover(`grouped_question-smile-happy`, { grouped_question: item })">
                                            <div class="image smile">
                                                <img src="@/assets/icons/smile-simple.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="info-text">{{translate('own_Happy')}}</span>
                                                <b>{{item.happy}}</b>
                                            </div>
                                        </div>
                                        <div
                                            class="rates-item pointer rates-section popover-target"
                                            :id="`grouped_question-smile-soso-${item.questions[0].uid}`"
                                            @click="onShowPopover(`grouped_question-smile-soso`, { grouped_question: item })">
                                            <div class="image normal">
                                                <img src="@/assets/icons/normal-simple.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="info-text">{{translate('own_SoSo')}}</span>
                                                <b>{{item.ok}}</b>
                                            </div>
                                        </div>
                                        <div
                                            class="rates-item pointer rates-section popover-target"
                                            :id="`grouped_question-smile-sad-${item.questions[0].uid}`"
                                            @click="onShowPopover(`grouped_question-smile-sad`, { grouped_question: item })">
                                            <div class="image sad">
                                                <img src="@/assets/icons/sad-simple.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="info-text">{{translate('own_Sad')}}</span>
                                                <b>{{item.sad}}</b>
                                            </div>
                                        </div>
                                        <!--                                        <div class="overlay">-->
                                        <!--                                            <span class="good"-->
                                        <!--                                                  :style="{ width: calcWidth(item, item.happy) }"></span>-->
                                        <!--                                            <span class="soso"-->
                                        <!--                                                  :style="{ width: calcWidth(item, item.ok) }"></span>-->
                                        <!--                                            <span class="sad"-->
                                        <!--                                                  :style="{ width: calcWidth(item, item.sad) }"></span>-->
                                        <!--                                        </div>-->
                                    </div>
                                </li>
                                <div class="comments-btn__wrapper">
                                    <li class="comments-btn-group pointer" v-if="item.total !== 0"
                                        @click="onShowPopover(`grouped_question-smile-happy`, { grouped_question: item })">
                                        <div class="comments-btn">
                                            <img alt="" src="@/assets/icons/ic_data_index.svg">
                                            <div>
                                                <span>{{translate('IndexAirvote')}}</span>
                                                <b>
                                                    {{item.index}}
                                                </b>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="comments-btn-group" v-if="item.questions.length > 0" :class="{hide: searchFilter != ''}">
                                        <button
                                            v-if="item.comments > 0"
                                            class="comments-btn" @click="openComments({
                                                    place: item
                                                })">
                                            <img src="@/assets/icons/ic_comment.svg" alt="">
                                            <div>
                                                <span>{{translate('Comments')}}</span>
                                                <b>{{item.comments}}</b>
                                            </div>
                                        </button>
                                    </li>
                                </div>

                            </ul>
                        </div>
                        <div class="content"
                             :class="{'collapsed': item.show}"
                             v-if="!item.show">
                            <ul :class="RenderClass" :key="RenderClass" v-if="RenderClass == 'desktop'">
                                <li class="content-row top-row col-title-list" >
                                    <div class="sort-col-wrapper" v-if="showReportByChosen.tag == 'by_sites'">
                                        <span :class="innerSorting.sortTypeFirst === 'text' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('text')">{{translate('Question')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'text' && showReportByChosen.tag == 'by_sites'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'text' && showReportByChosen.tag == 'by_sites'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper" v-else-if="showReportByChosen.tag != 'by_locations'">
                                        <span :class="innerSorting.sortTypeFirst === 'place_name' ? 'col-title-underlined': '' "
                                            @click="onColumnNameClick('place_name')">{{translate('Location')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'place_name' && showReportByChosen.tag != 'by_locations'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'place_name' && showReportByChosen.tag != 'by_locations'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper" v-else>
                                        <span :class="innerSorting.sortTypeFirst === 'place_name' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('place_name')">{{translate('site')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'place_name'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'place_name'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper" v-if="showReportByChosen.tag == 'by_locations'">
                                        <span :class="innerSorting.sortTypeFirst === 'text' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('text')">{{translate('Question')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'text' && showReportByChosen.tag == 'by_locations'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'text' && showReportByChosen.tag == 'by_locations'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper" v-if="showReportByChosen.tag == 'by_questions'">
                                        <span :class="innerSorting.sortTypeFirst === 'optional' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('optional')"></span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'optional' && showReportByChosen.tag == 'by_questions'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'optional' && showReportByChosen.tag == 'by_questions'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper" v-if="showReportByChosen.tag == 'by_sites'">
                                        <span :class="innerSorting.sortTypeFirst === 'optional' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('optional')">{{translate('Location')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'optional' && showReportByChosen.tag == 'by_sites'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'optional' && showReportByChosen.tag == 'by_sites'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper QR">
                                        <span class="id right-float">QR</span>
                                    </div>
                                    <div class="sort-col-wrapper">
                                        <span :class="innerSorting.sortTypeFirst === 'total_votes' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('total_votes')">{{totalQuestions <= 100 ? translate('Diagram') : translate('Comments')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'total_votes'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'total_votes'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper">
                                        <span :class="innerSorting.sortTypeFirst === 'happy' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('happy')">{{translate('own_Happy')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'happy'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'happy'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper">
                                        <span :class="innerSorting.sortTypeFirst === 'ok' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('ok')">{{translate('own_SoSo')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'ok'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'ok'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper">
                                        <span :class="innerSorting.sortTypeFirst === 'sad' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('sad')">{{translate('own_Sad')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'sad'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'sad'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                    <div class="sort-col-wrapper">
                                        <span :class="innerSorting.sortTypeFirst === 'id' ? 'col-title-underlined': '' "
                                              @click="onColumnNameClick('id')"
                                              class="id right-float">{{translate('ID')}}</span>
                                        <img v-if="innerSorting.sortDir == -1 && innerSorting.sortColumn == 'id'" src="@/assets/icons/chevron-down-solid.svg">
                                        <img v-if="innerSorting.sortDir == 1 && innerSorting.sortColumn == 'id'" src="@/assets/icons/chevron-up-solid.svg">
                                    </div>
                                </li>
                                <li :key="question.uid" class="content-row" v-for="(question, index) in item.questions"
                                    v-if="index < item.itemsShow" :style="{'grid-template-columns': showReportByChosen.tag == 'by_questions' ? 'auto 15px 20px 112px 80px 80px 80px 40px 20px' : 'auto 284px 20px 112px 80px 80px 80px 40px 20px;'}">
                                    <div class="content-image">
                                        <img v-if="question.place_preview && showReportByChosen.tag == 'by_locations' && totalQuestions <= 100"
                                             :src="question.place_preview">
                                        <span v-if="showReportByChosen.tag == 'by_sites'">{{question.text}}</span>
                                        <span v-else-if="siteListDropdown.length == 1" class="question-ext_placement ext_placement" :class="{hide: showReportByChosen.tag == 'by_locations'}" @click="onExtendedPlacementClick(question)">{{question.extended_placement ? question.extended_placement : translate('own_ExtPlacementEdit')}}</span>
                                        <span v-else class="ext_placement" @click="onExtendedPlacementClick(question)">{{question.extended_placement ? question.extended_placement : translate('own_ExtPlacementEdit')}}</span>
                                    </div>
                                    <div class="optional">
                                        <span v-if="showReportByChosen.tag == 'by_locations'">{{question.text}}</span>
                                        <span v-if="showReportByChosen.tag == 'by_sites'" class="ext_placement"@click="onExtendedPlacementClick(question)">
                                            {{question.extended_placement ? question.extended_placement : translate('own_ExtPlacementEdit')}}
                                        </span>
                                    </div>
                                    <div class="QRSticker__image" @click="onQuestionMenuPdfClick(question)" @dragend="onQuestionQRDoubleClick(question)">
                                        <img src="@/assets/icons/helpCenterFeedback.svg">
                                        <textarea :id="question.id" type="hidden" style="position: absolute; left: -10000px;"/>
                                    </div>
                                    <div class="dash-sector">
                                        <div class="dash" v-if="totalQuestions <= 100">
                                            <div class="dash_item">
                                                <b-button :id="`question-dash-happy-${question.uid}`"
                                                          @click="onShowPopover(`question-dash-happy`,  {question: question})"
                                                          class="dash-button good"
                                                          :style="{ width: calcWidth(question, question.happy) }"
                                                          :title="translate('own_Happy') + ' (' + calcWidth(question, question.happy, true) + ')'"
                                                ></b-button>
                                                <b-button :id="`question-dash-soso-${question.uid}`"
                                                          @click="onShowPopover(`question-dash-soso`,  {question: question})"
                                                          class="dash-button soso"
                                                          :style="{ width: calcWidth(question, question.ok) }"
                                                          :title="translate('own_SoSo') + ' (' + calcWidth(question, question.ok, true) + ')'"
                                                ></b-button>
                                                <b-button :id="`question-dash-sad-${question.uid}`"
                                                          @click="onShowPopover(`question-dash-sad`, {question: question})"
                                                          class="dash-button meh"
                                                          :style="{ width: calcWidth(question, question.sad) }"
                                                          :title="translate('own_Sad') + ' (' + calcWidth(question, question.sad, true) + ')'"
                                                ></b-button>
                                            </div>
                                        </div>
                                        <button
                                                v-if="question.comments > 0"
                                                class="comments-btn" @click="openComments({
                                                    question
                                                })">
                                            <!--                                            <span>{{translate('Comments')}}</span>-->
                                            <img src="@/assets/icons/ic_comment.svg" alt="">
                                            <span>{{question.comments}}</span>
                                        </button>
                                    </div>
                                    <div class="rate-count good">
                                        <div class="rate-count rates-section popover-target"
                                             :class="{column: shouldShowAnswer(question)}"
                                             :id="`question-smile-happy-${question.uid}`"
                                             @click="onShowPopover(`question-smile-happy`, { question: question })">
                                            <div class="smiley-count">
                                                <div class="image smile">
                                                    <img src="@/assets/icons/smile-simple.svg" alt="">
                                                </div>
                                                <span class="count">{{question.happy}}</span>
                                            </div>
                                            <span class="question-answer" v-if="shouldShowAnswer(question)">{{question.green}}</span>
                                        </div>
                                    </div>
                                    <div class="rate-count soso">
                                        <div class="rate-count rates-section popover-target"
                                             :class="{column: shouldShowAnswer(question)}"
                                             :id="`question-smile-soso-${question.uid}`"
                                             @click="onShowPopover(`question-smile-soso`, { question: question })">
                                            <div class="smiley-count">
                                                <div class="image normal">
                                                    <img src="@/assets/icons/normal-simple.svg" alt="">
                                                </div>
                                                <span class="count">{{question.ok}}</span>
                                            </div>
                                            <span class="question-answer" v-if="shouldShowAnswer(question)">{{question.yellow}}</span>
                                        </div>
                                    </div>
                                    <div class="rate-count sad">
                                        <div class="rate-count rates-section popover-target"
                                             :class="{column: shouldShowAnswer(question)}"
                                             :id="`question-smile-sad-${question.uid}`"
                                             @click="onShowPopover(`question-smile-sad`, { question: question })">
                                            <div class="smiley-count">
                                                <div class="image sad">
                                                    <img src="@/assets/icons/sad-simple.svg" alt="">
                                                </div>
                                                <span class="count">{{question.sad}}</span>
                                            </div>
                                            <span class="question-answer" v-if="shouldShowAnswer(question)">{{question.red}}</span>
                                        </div>
                                    </div>
                                    <div class="id right-float">#{{question.id}}</div>
                                    <div class="menu-sector" v-if="totalQuestions <= 100">
                                        <div class="menu-section" @click="hidePopover">
                                            <!--                                            <span class="id">#{{question.id}}</span>-->
                                            <div class="menu">
                                                <b-dropdown no-caret>
                                                    <b-dropdown-item
                                                            @click.stop="onQuestionMenuEditClick(item, question)"
                                                            v-if="hasEditPermission">
                                                        <img src="@/assets/icons/ic_edit.svg" alt="icon edit">
                                                        <span>{{translate('own_EditQuestion')}}</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item @click.stop="goToSecondLevelDetails(item, question)" v-if="checkIfOwnerHaveOriginalCredential()">
                                                        <img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
                                                        <span>{{ translate('sldSecondLevelDetails') }} Ⓐ</span>
                                                    </b-dropdown-item>
													<b-dropdown-item @click.stop="goToServiceLogScreen(item, question)" v-if="checkIfOwnerHaveOriginalCredential()">
														<img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
														<span>{{ translate('serviceLog') }} Ⓐ</span>
													</b-dropdown-item>
<!--                                                    <b-dropdown-item @click.stop="onQuestionMenuPdfClick(question)">-->
<!--                                                        <img src="@/assets/icons/ic_pdf.svg" alt="icon pdf">-->
<!--                                                        <div v-if="windowWidth">-->
<!--                                                            <span>{{translate('own_DownloadPDFMobile')}}</span>-->
<!--                                                        </div>-->
<!--                                                        <div v-else>-->
<!--                                                            <span>{{translate('own_DownloadPDF')}}</span>-->
<!--                                                        </div>-->
<!--                                                    </b-dropdown-item>-->
                                                    <b-dropdown-item
                                                            @click.stop="onQuestionMenuDeleteClick(item, question)"
                                                            v-if="hasEditPermission">
                                                        <img src="@/assets/icons/ic_trash.svg" alt="icon trash">
                                                        <span class="red-action">{{translate('own_DeleteQuestion')}}</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <b-button @click="showMoreForItem(item)" class="primaryButton sub-items-show-more"
                                          v-if="item.showMoreButton">{{translate('own_showMore')}}
                                </b-button>
                            </ul>
                            <ul :class="RenderClass" :key="RenderClass" v-if="RenderClass == 'mobile'">

                                <li :key="question.uid" class="content-row" v-for="(question, index) in item.questions"
                                    v-if="index < item.itemsShow">

                                    <div class="content-container">
                                        <div class="grid">
                                            <label v-if="showReportByChosen.tag != 'by_questions'">{{showReportByChosen.tag == 'by_sites' ? translate('Question') :
                                                translate('site')}}:</label>
                                            <div v-if="showReportByChosen.tag != 'by_questions'">
                                                <span v-if="showReportByChosen.tag == 'by_sites'">{{question.text}}</span>
                                                <span v-else class="ext_placement" @click="onExtendedPlacementClick(question)">{{question.extended_placement ? question.extended_placement : translate('own_ExtPlacementEdit')}}</span>
                                            </div>
                                            <label>{{showReportByChosen.tag == 'by_locations' ? translate('Question') :
                                                translate('Location')}}:</label>
                                            <div v-if="showReportByChosen.tag == 'by_locations'">{{question.text}}</div>
                                            <div v-else class="ext_placement" @click="onExtendedPlacementClick(question)">{{question.extended_placement ? question.extended_placement : translate('own_ExtPlacementEdit')}}</div>
                                            <label v-if="totalQuestions <= 100">{{translate('Diagram')}}:</label>
                                            <div class="dash-sector" v-if="totalQuestions <= 100">
                                                <div class="dash">
                                                    <div class="dash_item">
                                                        <b-button :id="`question-dash-happy-${question.uid}`"
                                                                  @click="onShowPopover(`question-dash-happy`,  {question: question})"
                                                                  class="dash-button good"
                                                                  :style="{ width: calcWidth(question, question.happy) }"
                                                                  :title="translate('own_Happy') + ' (' + calcWidth(question, question.happy, true) + ')'"
                                                        ></b-button>
                                                        <b-button :id="`question-dash-soso-${question.uid}`"
                                                                  @click="onShowPopover(`question-dash-soso`,  {question: question})"
                                                                  class="dash-button soso"
                                                                  :style="{ width: calcWidth(question, question.ok) }"
                                                                  :title="translate('own_SoSo') + ' (' + calcWidth(question, question.ok, true) + ')'"
                                                        ></b-button>
                                                        <b-button :id="`question-dash-sad-${question.uid}`"
                                                                  @click="onShowPopover(`question-dash-sad`, {question: question})"
                                                                  class="dash-button meh"
                                                                  :style="{ width: calcWidth(question, question.sad) }"
                                                                  :title="translate('own_Sad') + ' (' + calcWidth(question, question.sad, true) + ')'"
                                                        ></b-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <label>{{translate('ID')}}:</label>
                                            <div>#{{question.id}}</div>
                                        </div>

                                        <div class="smile-section" :class="{answers: shouldShowAnswer(question)}">
                                            <div class="rate-count good">
                                                <div class="rate-count rates-section popover-target"
                                                     :id="`question-smile-happy-${question.uid}`"
                                                     @click="onShowPopover(`question-smile-happy`, { question: question })">
                                                    <div class="smiley-count">
                                                        <div class="image smile">
                                                            <img src="@/assets/icons/smile-simple.svg" alt="">
                                                        </div>
                                                        <span class="count">{{question.happy}}</span>
                                                    </div>
                                                    <span class="question-answer question-answer-row" v-if="shouldShowAnswer(question)">{{question.green}}</span>
                                                </div>
                                            </div>
                                            <div class="rate-count soso">
                                                <div class="rate-count rates-section popover-target"
                                                     :id="`question-smile-soso-${question.uid}`"
                                                     @click="onShowPopover(`question-smile-soso`, { question: question })">
                                                    <div class="smiley-count">
                                                        <div class="image normal">
                                                            <img src="@/assets/icons/normal-simple.svg" alt="">
                                                        </div>
                                                        <span class="count">{{question.ok}}</span>
                                                    </div>
                                                    <span class="question-answer question-answer-row" v-if="shouldShowAnswer(question)">{{question.yellow}}</span>
                                                </div>
                                            </div>
                                            <div class="rate-count sad">
                                                <div class="rate-count rates-section popover-target"
                                                     :id="`question-smile-sad-${question.uid}`"
                                                     @click="onShowPopover(`question-smile-sad`, { question: question })">
                                                    <div class="smiley-count">
                                                        <div class="image sad">
                                                            <img src="@/assets/icons/sad-simple.svg" alt="">
                                                        </div>
                                                        <span class="count">{{question.sad}}</span>
                                                    </div>
                                                    <span class="question-answer question-answer-row" v-if="shouldShowAnswer(question)">{{question.red}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                                v-if="question.comments > 0"
                                                class="comments-btn" @click="openComments({
                                                    question
                                                })">
                                            <!--                                            <span>{{translate('Comments')}}</span>-->
                                            <img src="@/assets/icons/ic_comment.svg" alt="">
                                            <span>{{question.comments}}</span>
                                        </button>
                                    </div>
                                    <div class="menu-sector" v-if="totalQuestions <= 100">
                                        <div class="menu-section">
                                            <div class="menu">
                                                <b-dropdown no-caret>
                                                    <b-dropdown-item
                                                            @click.stop="onQuestionMenuEditClick(item, question)"
                                                            v-if="hasEditPermission">
                                                        <img src="@/assets/icons/ic_edit.svg" alt="icon edit">
                                                        <span>{{translate('own_EditQuestion')}}</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item @click.stop="goToSecondLevelDetails(item, question)" v-if="checkIfOwnerHaveOriginalCredential()">
                                                        <img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
                                                        <span>{{ translate('sldSecondLevelDetails') }} Ⓐ</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item @click.stop="goToServiceLogScreen(item, question)" v-if="checkIfOwnerHaveOriginalCredential()">
                                                        <img src="@/assets/icons/ic_cogs.svg" alt="icon analytic">
                                                        <span>{{ translate('serviceLog') }} Ⓐ</span>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item @click.stop="onQuestionMenuPdfClick(question)">
                                                        <img src="@/assets/icons/ic_pdf.svg" alt="icon pdf">
                                                        <div v-if="windowWidth">
                                                            <span>{{translate('own_DownloadPDFMobile')}}</span>
                                                        </div>
                                                        <div v-else>
                                                            <span>{{translate('own_DownloadPDF')}}</span>
                                                        </div>
                                                    </b-dropdown-item>
                                                    <b-dropdown-item
                                                            @click.stop="onQuestionMenuDeleteClick(item, question)"
                                                            v-if="hasEditPermission">
                                                        <img src="@/assets/icons/ic_trash.svg" alt="icon trash">
                                                        <span>{{translate('own_DeleteQuestion')}}</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <b-button @click="showMoreForItem(item)" class="primaryButton sub-items-show-more"
                                          v-if="item.showMoreButton">{{translate('own_showMore')}}
                                </b-button>
                            </ul>
                        </div>
                    </li>
                </ul>
                <div v-else class="none-result">
                    {{noneResult}}
                </div>
            </div>
        </div>
        <div v-else class="block-spinner">
            <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
// import VueApexCharts from "vue-apexcharts";
import moment from 'moment'
import {MdCheckbox} from 'vue-material/dist/components'
import '@/assets/css/MdCheckbox.css'

import 'vue-material/dist/vue-material.min.css'
import "@/assets/css/ownerPanel.css";
import "@/assets/css/analyticReportTable.css";
import customModalSuggests from '@/components/widgets/customModalSuggests';
import logAnalyticsEvent, {logError} from '@/helpers/analytics'
import config from '@/api/config';
import errorMixin from '@/mixins/errorMixin';
import helpPopupMixin from "@/mixins/helpPopupMixin";
import questionMixin from "@/mixins/questionMixin";
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import customModalSidebar from '@/components/widgets/customModalSidebar';
import customModalDialog from '@/components/widgets/customModalDialog';
import questionActionSidebar from '@/components/widgets/questionActionSidebar';
import pdfTypeSelectionDialog from '@/components/widgets/pdfTypeSelectionDialog';
import welcomeModal from '@/components/widgets/welcomeModal';
import amcharts from '@/components/widgets/amcharts';
import {dynamicSortMultiple} from '@/helpers/sorter';
import moreOptionsSidebar from "@/components/widgets/moreOptionsSidebar";
import airLeadDashboard from "@/components/owner-management/airLeadDashboard";
// import 'vue-material/dist/theme/default.css'
    Vue.use(MdCheckbox)

    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'fas fa-arrow-up',
            down: 'fas fa-arrow-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-calendar-check',
            clear: 'far fa-trash-alt',
            close: 'far fa-times-circle'
        }
    });

    const happyColor = '#228e00'
    const sosoColor = '#ff9d00'
    const sadColor = '#b51700'

    let tooltipTranslate = {
        today: "Go to today",
        clear: "Clear selection",
        close: "Close the picker",
        selectMonth: "Select Month1",
        prevMonth: "Previous Month",
        nextMonth: "Next Month",
        selectYear: "Select Year",
        prevYear: "Previous Year",
        nextYear: "Next Year",
        selectDecade: "Select Decade",
        prevDecade: "Previous Decade",
        nextDecade: "Next Decade",
        prevCentury: "Previous Century",
        nextCentury: "Next Century",
        pickHour: "Pick Hour",
        incrementHour: "Increment Hour",
        decrementHour: "Decrement Hour",
        pickMinute: "Pick Minute",
        incrementMinute: "Increment Minute",
        decrementMinute: "Decrement Minute",
        pickSecond: "Pick Second",
        incrementSecond: "Increment Second",
        decrementSecond: "Decrement Second",
        togglePeriod: "Toggle Period",
        selectTime: "Select Time"
    }


    export default {
        name: 'tabAnalytics',
        mixins: [errorMixin, helpPopupMixin, questionMixin],
        data() {
            return {
                searchFilter: "",
                showDateFrom: false,
                showDateTo: false,
                showOrderBanner: false,
                optionsFrom: {
                    format: 'MM/DD/YYYY H:mm', // https://momentjs.com/docs/#/displaying/
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    tooltips: tooltipTranslate,
                    // locale: 'ua',
                    keyBinds: false
                },
                optionsTo: {
                    format: 'MM/DD/YYYY H:mm', // https://momentjs.com/docs/#/displaying/
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    tooltips: tooltipTranslate,
                    keyBinds: false
                },
                noneResult: this.translate('No_votes'),
                reportItems: {},
                totalQuestions: 0,
                airvoteIndex: 0,
                items: {}, //deprecated
                places: {}, //deprecated
                selectedStikerArr: [],
                multiSelectFlag: false,
                pageLoad: true,
                toggleCheck: false,
                pdfTypeSelectionDialogSettings: {},
                customModalSettings: {},
                customSidebarSettings: {},
                questionActionSidebarSettings: {},
                moreOptionsSidebarSettings: {},
                siteListDropdown: [],
                isVisibleDropdown: false,
                CollapsedBlocks: new Set(),
                showPopoverBool: false,
                showPopoverTarget: '',
                latestChartZoom: {
                    dateFrom: undefined, //in seconds
                    dateTo: undefined, //in seconds
                    minDateFrom: undefined,
                    maxDateTo: undefined,
                    initialDateFrom: undefined, //in seconds
                    initialDateTo: undefined, //in seconds
                    initialDateType: 'day',
                    navHistory: [],
                    categories: []
                },
                currentDateType: null,
                currentQuestion: null,
                currentPopoverType: null,
                showPopover: {},
                series: [
                    {
                        name: this.translate('own_Happy'),
                        data: []
                    },
                    {
                        name: this.translate('own_SoSo'),
                        data: []
                    },
                    {
                        name: this.translate('own_Sad'),
                        data: []
                    }
                ],
                generalCount: {
                    isVisible: false,
                    happy: 1,
                    ok: 1,
                    sad: 1
                },
                questionIds: null,
                placeIds: null,
                showPlaces: true,
                RenderClass: 'desktop',
                amchartsData: null,
                customModalSuggests: {},
                welcomeModalSettings: {},
                innerSorting: {
                    sortTypeFirst: 'place_name',
                    sortLogic: ['place_name', 'optional'],
                    sortDir: 1,
                    sortColumn: '',
                },
                pageShowCount: window.innerWidth > 1000 ? 100 : 50,
                windowWidth: null,
                reportItemsTotalVotes: null,
                showReportBy: [
                    {
                        tag: 'by_questions'
                    },
                    {
                        tag: 'by_sites'
                    },
                    {
                        tag: 'by_locations'
                    }
                ],
                showMobileFilter: false,
                infiniteAirleads: 0
            }
        },
        components: {
            datePicker,
            customModalSidebar,
            customModalDialog,
            questionActionSidebar,
            pdfTypeSelectionDialog,
            amcharts,
            customModalSuggests,
            welcomeModal,
            moreOptionsSidebar,
            airLeadDashboard
        },
        computed: {
            ...mapState({
                customDate: state => state.owner.customDate,
                analyticTimeFilter: state => state.owner.analyticTimeFilter,
                analyticSiteFilter: state => state.owner.analyticSiteFilter,
                analyticSiteFilterDefault: state => state.owner.analyticSiteFilterDefault,
                userInfo: state => state.auth.userInfo,
                isMultipleSites: state => state.auth.isMultipleSites,
                showReportByChosen: state => state.owner.showReportByChosen,
                isMobile: state => state.isMobile,
            }),

            ...mapGetters({
                getActiveTab: 'owner/getActiveTab',
                analyticTabIndex: 'owner/analyticTabIndex',
                getFormatedLang: 'getFormatedLang',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasEditPermission: 'auth/hasEditPermission',
                getSideBarToggle: 'owner/getSideBarToggle',
                isUserAirLeadManager: 'auth/isUserAirLeadManager',
                isAirLeadEnabled: 'auth/isAirLeadEnabled',
                hasServiceLogs: 'auth/hasServiceLogs',
                isServiceLogManager: 'auth/isServiceLogManager',
				getOrgUid: 'auth/getOrgUid'
            }),

            dateFromModel: {
                get: function () {
                    return new Date(this.customDate.date_from)
                },
                set: function (newValue) {
                    this.setCustomDate({
                        date_from: newValue
                    })
                    this.dateFrom = new Date(newValue).getTime()
                }
            },

            dateToModel: {
                get: function () {
                    return new Date(this.customDate.date_to)
                },
                set: function (newValue) {
                    this.setCustomDate({
                        date_to: newValue
                    })
                    this.dateTo = new Date(newValue).getTime()
                }
            }

        },

        watch: {
            getActiveTab(value) {
                if (value === this.analyticTabIndex) {
                    this.setActive(this.analyticTimeFilter.attr)
                }
            },
            showPlaces() {
                this.refreshReport()
            },
            showReportByChosen() {
                if (!this.isMobile) {
                    this.refreshReport()
                }
            },
            isMultipleSites() {
                this.dropdownVisibility()
            },
            'customDate.date_from'(val) {
                this.dateFromModel = val
            },
            'customDate.date_to'(val) {
                this.dateToModel = val
            },
            customSidebarSettings(val) {
                if (Object.keys(val).length) {
                    this.hidePopover()
                }
            },
            searchFilter(val) {
                this.applyFilter()
            },
            getSideBarToggle(val) {
                if(val) this.showMoreOption()
            },

        },

        beforeMount() {
            console.log(this.reportItems)
            this.fetchUserInfo()
                .then((responce) => {
                    this.dropdownVisibility()
                })
        },

        async mounted() {
            window.addEventListener('scroll', (event) => {
                this.scrollY = Math.round(window.scrollY);
            });
            if (this.makeOwnerBool) {
                this.$router.push({name: 'Login'})
            }
            this.windowWidth = window.matchMedia('(max-width: 500px)').matches

            await this.loadPanel()

            this.RenderClass = window.innerWidth > 1000 ? 'desktop' : 'mobile'
            window.addEventListener('resize', () => {
                this.RenderClass = window.innerWidth > 1000 ? 'desktop' : 'mobile'
                this.myPopover()
            });

            window.addEventListener('scroll', () => {
                this.myPopover()
            });

            this.$root.$on('bv::dropdown::show', bvEvent => {
                this.hidePopover()
            })


            if(this.$route.query.vp == 's') {
                this.openVotes()
            }
        },

        methods: {

            ...mapActions({
                fetchUserInfo: 'auth/fetchUserInfo',
                getQuestionsAction: 'question/getQuestions',
                getOwnerReportAction: 'owner/getOwnerReport',
                getManagerReportAction: 'owner/getManagerReport',
                updateQuestionAction: 'question/updateQuestion',
                deleteQuestionAction: 'question/deleteQuestion',
                addQuestionToSiteAction: 'organization/addQuestionToSite',
                getChartInfoByQuestion: 'question/getChartInfoByQuestion',
                openFileReport: 'organization/openFileReport',
                checkReport: 'organization/checkReport',
                getReportOnMobile: 'organization/getReportOnMobile',
                logUserAction: 'owner/logUserAction',
            }),

            ...mapMutations({
                setAnalyticFilter: 'owner/setAnalyticFilter',
                setShowReportValue: 'owner/showReportByFilter',
                setSiteListDropdown: 'owner/setSiteListDropdown',
                setCustomDate: 'owner/setCustomDate',
                setProgressBarTag: 'setProgressBarTag'
            }),

            openComments({question, place}) {
                this.hidePopover()
                this.customSidebarSettings = {
                    dateFrom: this.dateFromModel,
                    dateTo: this.dateToModel,
                    comments: {
                        siteName: question ? question.place_name : null,
                        question: question ? question.text : null,
                        optional: question ? question.optional : null,
                        asset_id: question ? question.asset_id : null,
                        questionUids: question ? [question.uid] : place.questions.map(item => item.uid),
                        placeTitle: place ? place.title : null
                    }
                }
            },

            openVotes() {
                this.setQueryParam('vp', 's')
                this.hidePopover()
                this.customSidebarSettings = {
                    votes: {},
                    wide: true,
                    onCancelAction: () => {
                        this.setQueryParam('vp', 'h')
                    },
                }
            },

            setQueryParam(key, value) {
                let newParams = {}
                newParams[key] = value;
                this.$router.push({ query: Object.assign({}, this.$route.query, newParams) });
            },

            getEditingPlaceUID() {
                if (this.siteListDropdown.length > 1) {
                    return this.analyticSiteFilter.uid
                } else {
                    return this.siteListDropdown[0].uid
                }
            },

            showReportByFilter(item) {
                this.CollapsedBlocks.clear()
                this.setShowReportValue(item)
                this.refreshReport()
            },

            dropdownVisibility() {
                if (this.siteListDropdown.length > 1) {
                    this.isVisibleDropdown = true
                } else {
                    this.isVisibleDropdown = false
                }
            },

            async chooseSite(item) {
                this.setAnalyticFilter({
                    analyticSiteFilter: item
                })
                await this.refreshReport()
            },

            selectedStiker(uid) {
                if (this.multiSelectFlag) {
                    const index = this.selectedStikerArr.indexOf(uid);
                    if (index != -1) {
                        // this.selectedStikerArr = []
                        this.selectedStikerArr.splice(index, 1)
                    } else {
                        // this.selectedStikerArr = [uid]
                        this.selectedStikerArr.push(uid)
                    }
                }
            },

            async loadPanel() {
                await this.setActive(this.analyticTimeFilter.attr)
            },

            async onHitDate(date) {
                let dateM = +moment(date, "YYYY-MM-DD HH:mm").format('X')
                var dateFrom = dateM - 3600 * 10
                var dateTo = dateM + 3600 * 10
                var dateType = this.currentDateType
                switch (this.currentDateType) {
                    case 'hour': {
                        return
                    }
                    case 'day': {
                        dateType = "hour"
                        dateFrom = dateM - 3600 * 1
                        dateTo = dateM + 3600 * 25
                        break
                    }
                    case 'month': {
                        dateType = "day"
                        dateFrom = dateM
                        dateTo = dateM + 3600 * 24 * 30
                        break
                    }
                }
                await this.loadChartData(dateFrom, dateTo, dateType)
            },

            onResetChart() {
                this.loadChartData(this.latestChartZoom.initialDateFrom, this.latestChartZoom.initialDateTo, this.latestChartZoom.initialDateType, false, true)
            },

            myPopover() {
                if (this.showPopoverTarget) {
                    const popover = document.querySelector('.myPopover')
                    const arrow = document.querySelector('.myPopover .arrow')
                    const el = document.getElementById(this.showPopoverTarget)
                    const topClass = 'bs-popover-top';
                    const bottomClass = 'bs-popover-bottom';
                    const elCoord = el.getBoundingClientRect();
                    const popoverCoord = popover.getBoundingClientRect();
                    const windowHeight = window.innerHeight;

                    if ((elCoord.bottom + 5 + popoverCoord.height - elCoord.height) >= windowHeight) {
                        if (popover.classList.contains(bottomClass)) {
                            popover.classList.remove(bottomClass)
                            popover.classList.add(topClass)
                        }
                        if ((elCoord.bottom - elCoord.height + 5) >= windowHeight) {
                            popover.style.transform = 'translate3d(5px, ' + (windowHeight - popoverCoord.height - 5) + 'px, 0px)'
                        } else {
                            popover.style.transform = 'translate3d(5px, ' + (elCoord.top - popoverCoord.height - 5) + 'px, 0px)'
                        }
                    } else {
                        if (popover.classList.contains(topClass)) {
                            popover.classList.remove(topClass)
                            popover.classList.add(bottomClass)
                        }
                        if (elCoord.y + elCoord.height < 10) {
                            popover.style.transform = 'translate3d(5px, ' + 5 + 'px, 0px)'
                        } else {
                            popover.style.transform = 'translate3d(5px, ' + Math.round(elCoord.bottom) + 'px, 0px)'
                        }
                    }

                    arrow.style.left = (Math.round(elCoord.left) + (elCoord.width / 2) - 20) + 'px'
                }
            },

            hidePopover() {
                if (this.showPopoverBool) {
                    this.showPopoverBool = false;
                }
            },

            async onShowPopover(popoverType, target) {

                const key = Object.keys(target)[0]
                let targetId = null
                this.questionIds = null
                this.placeIds = null
                let dateFrom
                let dateTo = +moment(this.dateTo).format('X')

                switch (key) {
                    case 'question': {
                        this.currentQuestion = target[key]
                        this.questionIds = [target[key].uid]
                        targetId = target[key].uid
                        break
                    }
                    case 'grouped_question': {
                        this.currentQuestion = target[key]
                        this.questionIds = target[key].questions.map(item => item.uid)
                        targetId = target[key].questions[0].uid
                        break
                    }
                    case 'place': {
                        this.currentQuestion = target[key]
                        this.placeIds = [target[key].uid]
                        targetId = target[key].uid
                        break
                    }
                    case 'org': {
                        this.placeIds = target[key].map(item => item.uid)
                        break
                    }
                    default : {
                        this.hidePopover()
                        this.showPopoverTarget = ``;
                    }
                }
                this.showPopoverBool = true;
                this.showPopoverTarget = key != 'org' ? `${popoverType}-${targetId}` : `${popoverType}`
                this.currentPopoverType = popoverType
                this.myPopover(popoverType)

                switch (this.analyticTimeFilter.attr) {
                    case 'day':
                        dateFrom = +moment(this.dateFrom).format('X')
                        break;

                    case 'week':
                        dateFrom = +moment(this.dateFrom).format('X')
                        break;

                    case 'all':
                        dateFrom = +moment().subtract(1, 'y').format('X')
                        break;

                    case 'custom':
                        dateFrom = +moment(this.customDate.date_from).format('X')
                        dateTo = +moment(this.customDate.date_to).format('X')
                        break;
                }
                const dateType = this.getChartDateType(dateFrom, dateTo)
                this.currentDateType = dateType
                try {
                    this.latestChartZoom.dateFrom = undefined
                    this.latestChartZoom.dateTo = undefined
                    this.latestChartZoom.navHistory = []
                    await this.loadChartData(dateFrom, dateTo, dateType)
                    this.latestChartZoom.initialDateFrom = dateFrom
                    this.latestChartZoom.initialDateTo = dateTo
                    this.latestChartZoom.initialDateType = dateType
                    this.latestChartZoom.minDateFrom = dateFrom
                    this.latestChartZoom.maxDateTo = dateTo
                    this.myPopover()
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
                $(document).on('mousedown', e => {
                    if (($(".myPopover__wrapper").has(e.target).length === 0)) {
                        this.showPopoverBool = false;
                    }
                });

            },

            getChartDateType(dateFrom, dateTo) {
                let dateType
                const diffInHour = (dateTo - dateFrom) / 60 / 60
                const diffInDay = diffInHour / 24
                if (diffInHour < 48) {
                    dateType = 'hour'
                } else if (diffInHour >= 48 && diffInDay <= 60) {
                    dateType = 'day'
                } else {
                    dateType = 'month'
                }

                return dateType
            },

            chartPrevStep() {
                let item = this.latestChartZoom.navHistory.pop()
                if (item !== undefined) {
                    this.loadChartData(item.dateFrom, item.dateTo, item.dateType, true)
                }
            },

            async loadChartData(dateFrom, dateTo, dateType, isUndo = false, isRefresh = false) {
                if (isRefresh) {
                    this.latestChartZoom.navHistory = []
                }
                if (!isRefresh && !isUndo && this.latestChartZoom.dateFrom != undefined && this.latestChartZoom.dateTo != undefined) {
                    this.latestChartZoom.navHistory.push({
                        dateFrom: this.latestChartZoom.dateFrom,
                        dateTo: this.latestChartZoom.dateTo,
                        dateType: this.currentDateType
                    })
                }

                this.currentDateType = dateType
                this.latestChartZoom.dateFrom = dateFrom
                this.latestChartZoom.dateTo = dateTo

                const DateFromNewFormat = moment(new Date(+(dateFrom + '000'))).format("YYYY-MM-DD HH:mm:ss")
                const DateToNewFormat = moment(new Date(+(dateTo + '000'))).format("YYYY-MM-DD HH:mm:ss")


                let body = {
                    params: {
                        dateFrom: DateFromNewFormat,
                        dateTo: DateToNewFormat,
                        dateType
                    }
                }
                if (this.questionIds) {
                    body.questionIds = this.questionIds
                }
                if (this.placeIds) {
                    body.placeIds = this.placeIds
                }
                const response = await this.getChartInfoByQuestion(body)
                let indexes = []
                let minIndex = 100
                let maxIndex = 0
                for (let i = 0; i < response.happy.length; i++) {
                    let index = Math.round((response.happy[i] + response.ok[i] * 0.5) / ((response.happy[i] + response.ok[i] + response.sad[i])) * 100)
                    indexes.push(index)
                    if (index < minIndex) minIndex = index
                    if (index > maxIndex) maxIndex = index
                }
                response.indexes = indexes
                this.amchartsData = {
                    response,
                    popoverType: this.currentPopoverType,
                    currentDateType: this.currentDateType,
                    minIndex: minIndex,
                    maxIndex: maxIndex,
                }
            },

            cancelSelectedSticker() {
                this.selectedStikerArr = []
            },

            openDownloadPopap(question) {
                logAnalyticsEvent(`analytics_success_create_q_download_click`)
                const siteUid = this.getEditingPlaceUID()
                this.pdfTypeSelectionDialogSettings = {
                    siteUid,
                    question: question,
                    questionUID: question.uid,
                    guid: this.userInfo.guid,
                    popapButton: true,
                    format: 'default_with_hints',
                    sectionClass: 'full-width--btn',
                    icon: 'download-icon.svg',
                    panelLeafletIcon: 'leaflet.png',
                    panelBusinessIcon: 'card_en.png',
                    panelExtendedIcon: 'leaflet_extended.png',
                    onOkHandler: this.downloadPDFextended,
                    showCancelButton: true,
                    windowWidthCheck: this.windowWidth
                }

            },
            downloadPDFextended(question) {
                let type = 'pdf'
                if (question.format === 'business_card') {
                    type = 'card'
                }
                let link = `${config.baseUrl}/admin/questions/${question.questionUID}/${type}?language=${this.getFormatedLang}&sticker_type=${question.format}`
                const win = window.open(link, '_blank');
                win.focus();
            },
            moreOptionBtnClick() {
                this.showMoreOption()
            },
            showMoreOption() {
                this.moreOptionsSidebarSettings = {
                    title: this.translate('moreOptiosPopuoTitle'),
                    createQuestionHandler: this.modalAdd,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    placeUids: this.analyticSiteFilter.tag != 'all' ? [this.analyticSiteFilter.uid] : [],
                    bulkPlacementEditSuccess: this.refreshReport,
                    showAllVotesHandler: this.showAllVotesBtnClick
                }
                this.logAction('click_more_options')
            },
            showAllVotesBtnClick() {
              this.customSidebarSettings = {
                votes: true
              }
            },

            checkFilter() {
                let flag = true
                this.siteListDropdown.forEach(item => {
                    if (item.tag == this.analyticSiteFilter.tag) {
                        flag = false
                    }
                })
                if (flag) {
                    this.setAnalyticFilter({
                        analyticSiteFilter: this.analyticSiteFilterDefault
                    });
                }
            },
            async getReport(date_from, date_to) {
                this.hidePopover()
                let data = {
                    group: this.showReportByChosen.tag,
                }

                if (date_from) {
                    data.date_from_local = moment(new Date(date_from)).format("YYYY-MM-DD HH:mm:ss")

                }
                if (date_to) {
                    data.date_to_local = moment(new Date(date_to)).format("YYYY-MM-DD HH:mm:ss")
                }
                if (this.analyticSiteFilter.tag != 'all') {
                    data.place_uids = [this.analyticSiteFilter.uid];
                }
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'commentLoader'
                    })
                    const response = await this.getManagerReportAction(data)
                    if (response.success) {
                        this.siteListDropdown = []
                        this.items = response.items;
                        if (response.items) {
                            this.setCustomDate({
                                date_from: date_from ? date_from : undefined,
                                date_to: date_to ? date_to : undefined
                            })

                            response.available_places.forEach(item => {
                                this.siteListDropdown[this.siteListDropdown.length] = {
                                    tag: item.short_tag,
                                    uid: item.uid
                                }
                            })
                            this.applyFilter()
                            this.applyGroupBy()
                            this.setSiteListDropdown(this.siteListDropdown)

                            //todo show "change filter" if zero after filtering
                            if(response.items.length === 0 && response.show_zero_votes && this.hasEditPermission) {
                                logAnalyticsEvent(`analytics_auto_show_add_question`)
                                this.showAddQuestionSidebar()
                            }
                            if(response.limited_votes && response.limited_votes.total_count > 0) {
                                this.customModalSettings = {
                                    sectionClass: 'full-width--btn large',
                                    icon: 'close-circle-outline.svg',
                                    title: this.translate('own_limitedAccessDialogTitle'),
                                    message: this.translate('own_limitedAccessDialogBody', [response.limited_votes.total_count]),
                                    okButtonText: this.translate('own_limitedAccessDialogContactBtn'),
                                    onOkHandler: () => {
                                        location.href = 'mailto:team@air-vote.com?subject=Limited access'+'&body='+'';
                                    },
                                    showCancelButton: true,
                                    cancelButtonText: this.translate('Close'),
                                }
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    if (e.data.error.code == 1125 || e.data.error.code == 1135) {
                        this.places = false;
                        this.showErrorModal(e.data.error.message, {
                            title: 'Error',
                            code: e.data.error.code
                        })
                    } else {
                        this.showErrorModal()
                    }
                } finally {
                    setTimeout(() => {
                        this.dropdownVisibility()
                    }, 0)
                    this.checkFilter()
                    this.cancelSelectedSticker()
                    this.setProgressBarTag({
                        show: false,
                        tag: 'commentLoader'
                    })
                }

            },
            closeOrderBanner() {
                let getBannerCount = (+(localStorage.getItem('orderBanner') || 0) + 1)
                localStorage.setItem("orderBanner", getBannerCount)
                this.showOrderBanner = false
            },

            applyLoadMoreSettingsForItem(item) {
                item.itemsShow = item.questions.length > this.pageShowCount ? this.pageShowCount : item.questions.length
                item.showMoreButton = item.questions.length > item.itemsShow
            },
            redirectToOrderPage() {

            },

            onMainListItemClick(item) {
                item.show = !item.show
                this.applyLoadMoreSettingsForItem(item)
                if(item.show) {
                    this.CollapsedBlocks.add(item.title)
                } else {
                    this.CollapsedBlocks.delete(item.title)
                }
            },

            showMoreForItem(item) {
                item.showMoreButton = false
                let diff = item.questions.length - item.itemsShow
                diff = diff > this.pageShowCount ? this.pageShowCount : diff
                item.itemsShow += diff
                setTimeout(() => {
                    item.showMoreButton = item.questions.length > item.itemsShow
                }, 100);
            },

            refreshReport() {
                this.setActive(this.analyticTimeFilter.attr);
            },
            getToOrderPage() {
                this.$router.push({name: 'orderPage'})
                this.closeOrderBanner()

            },

            getMonth(month) {
                if (month == 0) {
                    return 12;
                } else {
                    return month - 1;
                }
            },

            async setActive(menuItem) {
                this.dateFrom = null
                this.dateTo = null
                this.hidePopover()
                this.customSidebarSettings = {}
                this.questionActionSidebarSettings = {}
                let oneDay = 86400000;
                let date = new Date();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();
                let currentHours = date.getHours() * 60 * 60 * 1000;
                let currentMinutes = date.getMinutes() * 60 * 1000;
                let currentSeconds = date.getSeconds() * 1000;
                let todayMidnight = new Date(date.getTime() - currentHours - currentMinutes - currentSeconds).getTime();
                let todayEnd = todayMidnight + oneDay - 1000
                let lastWeek = new Date(todayMidnight - (oneDay * 7)).getTime();
                let dayInLastMonth = new Date(year, this.getMonth(month), 0).getDate();
                switch (menuItem) {
                    case 'day': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_today',
                                attr: 'day'
                            }
                        })
                        this.dateFrom = todayMidnight;
                        this.dateTo = todayEnd + oneDay;
                        break;
                    }
                    case 'week': {
                        this.setAnalyticFilter({
                            analyticTimeFilter:
                                {
                                    name: 'own_last7days',
                                    attr: 'week'
                                }
                        })
                        this.dateFrom = todayMidnight - (oneDay * 6);
                        this.dateTo = todayEnd + oneDay;
                        break;
                    }
                    case 'month': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_lastMonth',
                                attr: 'month'
                            }
                        })
                        this.dateTo = new Date(todayMidnight - ((date.getDate() - 1) * oneDay)).getTime();
                        this.dateFrom = new Date(to - (dayInLastMonth * oneDay)).getTime();
                        break;
                    }
                    case 'all': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_allTime',
                                attr: 'all'
                            }
                        })
                        break;
                    }
                    case 'custom': {
                        this.setAnalyticFilter({
                            analyticTimeFilter: {
                                name: 'own_custom',
                                attr: 'custom'
                            }
                        })
                        if (this.customDate.date_from == undefined) {
                            this.setCustomDate({
                                date_from: new Date(lastWeek)
                            })
                            this.dateFromModel = new Date(lastWeek)
                        }
                        if (this.customDate.date_to == undefined) {
                            this.setCustomDate({
                                date_to: new Date(todayMidnight)
                            })
                            this.dateToModel = new Date(todayMidnight)
                        }
                        this.dateFrom = new Date(this.customDate.date_from).getTime()
                        this.dateTo = new Date(this.customDate.date_to).getTime()
                        break;
                    }
                }
                await this.getReport(this.dateFrom, this.dateTo)
            },

            calcWidth(obj, curent = 0, round) {
                if (obj && curent > 0) {
                    const total = obj.happy + obj.ok + obj.sad
                    const value = ((100 / total) / (100 / curent)) * 100;
                    if (round) {
                        return Math.round(value) + '%'
                    } else {
                        return value + '%'
                    }
                } else {
                    return '0%'
                }
            },

            modalAdd() {
                logAnalyticsEvent(`analytics_add_question_click`)
                this.showAddQuestionSidebar()
            },

            showAddQuestionSidebar() {
                this.questionActionSidebarSettings = {
                    title: this.translate('own_CreateNew'),
                    cancel: true,
                    questionRightClickHandler: this.onSuggestionsBtnClick,
                    questionItem: {
                        value: ''
                    },
                    locationItem: {
                        value: ''
                    },
                    assetID: {
                        value: ''
                    },
                    green: {
                        value: this.translate('own_Happy')
                    },
                    yellow: {
                        value: this.translate('own_SoSo')
                    },
                    red: {
                        value: this.translate('own_Sad')
                    },
                    buttons: [
                        {
                            text: this.translate('Save'),
                            action: this.addQuestion,
                            classList: 'invert_btn',
                            cleanData: false,
                        }
                    ],
                    dropdownChoose: this.siteListDropdown.length > 1 ? this.siteListDropdown[0] : null,
                    dropdown: this.siteListDropdown.length > 1 ? this.siteListDropdown : null
                }
            },

            async addQuestion(obj) {
                const body = {
                    count: 1,
                    text: obj.questionItem.value,
                    optional: obj.locationItem.value,
                    asset_id: obj.assetID.value,
                    green: obj.green.value,
                    yellow: obj.yellow.value,
                    red: obj.red.value,
                };
                try {
                    const response = await this.addQuestionToSiteAction({
                        body,
                        site_uid: obj.dropdownChoose ? obj.dropdownChoose.uid : this.siteListDropdown[0].uid
                    })
                    if (response.success) {
                        logAnalyticsEvent(`analytics_add_question_success`)
                        this.customModalSettings = {
                            sectionClass: 'full-width--btn large',
                            icon: 'ic_allow.svg',
                            title: this.translate('own_DownloadPDF_Title'),
                            message: this.translate('own_DownloadPDF_Description'),
                            okButtonText: this.translate('own_DownloadAndPrint'),
                            onOkHandler: this.openDownloadPopap.bind(null, response.qrs[0]),
                            uid: response.qrs[0].uid,
                            showCancelButton: true,
                            cancelButtonText: this.translate('Close'),
                        }

                        this.refreshReport();
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    logError(`analytics_add_question_error`, e.data.error.message)
                    if (e.data.error.code == 1118 || e.data.error.code == 1107) {
                        this.showErrorModal(e.data.error.message);
                    } else {
                        this.showErrorModal()
                    }
                }
            },

            onQuestionMenuEditClick(item, question) {
                logAnalyticsEvent(`analytics_question_menu_edit_click`)
                this.modalEdit(item, question)
            },

            onQuestionMenuPdfClick(question) {
                logAnalyticsEvent(`analytics_question_menu_pdf_click`)
                this.openDownloadPopap(question)
            },

            onQuestionQRDoubleClick(question) {
                console.log('dddd')
                logAnalyticsEvent(`analytics_question_qr_dbl_click`)
                let inputId = `${question.id}`
                let item = document.getElementById(inputId);
                item.value = this.getQuestionQRLinks(question)
                this.copyQrLinksToClipboard(inputId, {msg:'Links copied:)'})
            },

            getQuestionQRLinks(question) {
                return `🟩 ${location.origin}/r/rate/${question.uid}/3\n🟨 ${location.origin}/r/rate/${question.uid}/2\n🟥 ${location.origin}/r/rate/${question.uid}/1`
            },

            copyQrLinksToClipboard(itemId, messageData = null) {
                let item = document.getElementById(itemId);
                item.select();
                document.execCommand("copy");
                item.setSelectionRange(0, 0);
                if(messageData != null) {
                    this.setMessageModel({
                        msg: messageData.msg || this.translate('manageCopiedToClipboard'),
                        duration: messageData.duration || 700
                    })
                }
            },

            onQuestionMenuDeleteClick(item, question) {
                logAnalyticsEvent(`analytics_question_menu_delete_click`)
                this.deleteConfirm(item, question)
            },

            modalEdit(item, question) {
                this.questionActionSidebarSettings = {
                    title: this.translate('own_EditQuestion'),
                    cancel: true,
                    siteUid: question.site_uid,
                    questionUID: question.uid,
                    questionRightClickHandler: this.onSuggestionsBtnClick,
                    questionItem: {
                        value: question.text
                    },
                    questionValue: question,
                    locationItem: {
                        value: question.optional
                    },
                    assetID: {
                        value: question.asset_id
                    },
                    green: {
                        value: question.green
                    },
                    yellow: {
                        value: question.yellow
                    },
                    red: {
                        value: question.red
                    },
                    buttons: [
                        {
                            text: this.translate('Save'),
                            action: this.editQuestion,
                            classList: 'invert_btn',
                            cleanData: false
                        }
                    ]
                }
            },

            async editQuestion(obj) {
                const body = {
                    text: obj.questionItem.value,
                    optional: obj.locationItem.value,
                    asset_id: obj.assetID.value,
                    green: obj.green.value,
                    yellow: obj.yellow.value,
                    red: obj.red.value,
                };
                try {
                    const response = await this.updateQuestionAction({
                        questionId: obj.questionUID,
                        body,
                        siteUid: obj.siteUid
                    })
                    if (response.success) {
                        this.customModalSettings = {
                            sectionClass: 'full-width--btn',
                            icon: 'ic_allow.svg',
                            title: this.translate('own_DownloadPDF_EditTitle'),
                            okButtonText: 'OK',
                        }
                        this.questionActionSidebarSettings = null
                        let questionChanged = obj.questionValue.text !== obj.questionItem.value
                        let locationChanged = obj.locationItem.value !== obj.questionValue.optional
                        // let assetIdChanged = obj.assetID.value !== obj.questionValue.asset_id
                        obj.questionValue.asset_id = obj.assetID.value
                        obj.questionValue.green = obj.green.value
                        obj.questionValue.yellow = obj.yellow.value
                        obj.questionValue.red = obj.red.value
                        let reportBy = this.showReportByChosen.tag
                        let originalQuestionItem = this.findOriginalQuestionItem(obj.questionValue.uid)
                        originalQuestionItem.asset_id = obj.assetID.value
                        originalQuestionItem.green = obj.green.value
                        originalQuestionItem.yellow = obj.yellow.value
                        originalQuestionItem.red = obj.red.value
                        if ( reportBy == 'by_sites') {
                            obj.questionValue.text = obj.questionItem.value
                            obj.questionValue.optional = obj.locationItem.value
                            obj.questionValue.placement = obj.locationItem.value
                            originalQuestionItem.text = obj.questionItem.value
                            originalQuestionItem.optional = obj.locationItem.value //todo deprecated
                            originalQuestionItem.placement = obj.locationItem.value
                        } else if ( reportBy == 'by_questions' ) {
                            if (questionChanged) {
                                this.refreshReport()
                            } else {
                                obj.questionValue.optional = obj.locationItem.value
                                obj.questionValue.placement = obj.locationItem.value
                                originalQuestionItem.optional = obj.locationItem.value //todo deprecated
                                originalQuestionItem.placement = obj.locationItem.value
                            }
                        } else if (reportBy == 'by_locations') {
                            if (locationChanged) {
                                this.refreshReport()
                            } else {
                                obj.questionValue.text = obj.questionItem.value
                                originalQuestionItem.text = obj.questionItem.value
                            }
                        }
                        let newExPl = this.getExtendedPlacement(obj.questionValue)
                        obj.questionValue.extended_placement = newExPl
                    } else {
                        this.showErrorModal()
                    }
                } catch (e) {
                    if (e.data.error.code == 1118) {
                        this.showErrorModal(e.data.error_msg);
                    } else {
                        this.showErrorModal()
                    }
                }

            },

            findOriginalQuestionItem(guid) {
                for (let i = 0; this.items.length > i; i++) {
                    let block = this.items[i]
                    for (let j = 0; block.questions.length > j; j++) {
                        let question = block.questions[j]
                        if(question.uid == guid) return question
                    }
                }
                return null
            },

            applyGroupBy() {
                let placements = new Set()
                for (let i = 0; this.items.length > i; i++) {
                    let item = this.items[i]
                    for (let j = 0; item.questions.length > j; j++) {
                        placements.add(item.questions[j].placement)
                    }
                }
                if(placements.size > 30) {
                    this.showReportBy = [
                        {
                            tag: 'by_questions'
                        },
                        {
                            tag: 'by_sites'
                        }
                    ]
                } else {
                    this.showReportBy = [
                        {
                            tag: 'by_questions'
                        },
                        {
                            tag: 'by_sites'
                        },
                        {
                            tag: 'by_locations'
                        }
                    ]
                }
            },

            applyFilter() {
                let items = JSON.parse(JSON.stringify(this.items))
                let totalQ = 0
                let totalV = 0
                let newCollapsedBlocks = new Set()
                let newItems = []
                for (let i = 0; items.length > i; i++) {
                    let okForFilter = this.searchFilter == "" || this.compareSubstrings(this.searchFilter, items[i].title)
                    let questions = items[i].questions
                    if(!okForFilter) {
                        questions = items[i].questions.filter(q => {
                            let w3w = ''
                            if(q.location) w3w = q.location.w3w
                            return this.compareSubstrings(this.searchFilter, q.asset_id)
                                || this.compareSubstrings(this.searchFilter, q.placement)
                                || this.compareSubstrings(this.searchFilter, q.id)
                                || this.compareSubstrings(this.searchFilter, w3w)
                                || this.compareSubstrings(this.searchFilter, q.place_name)
                                || this.compareSubstrings(this.searchFilter, q.text)
                        })
                        if(questions.length > 0) okForFilter = true
                    }
                    let happy = 0, ok = 0, sad = 0
                    for (let i = 0; questions.length > i; i++) {
                        let q = questions[i]
                        happy += q.happy
                        ok += q.ok
                        sad += q.sad
                    }
                    //collapsed/load more
                    let wasCollapsed = this.CollapsedBlocks.has(items[i].title)
                    items[i].show = wasCollapsed || questions.length > 10
                    if(wasCollapsed) newCollapsedBlocks.add(items[i].title)
                    this.applyLoadMoreSettingsForItem(items[i])
                    //end collapsed/load more
                    totalQ += questions.length
                    items[i].questions = questions
                    //set extended_placement
                    for (let j = 0; questions.length > j; j++) {
                        let question = questions[j]
                        question.extended_placement = this.getExtendedPlacement(question)
                    }
                    items[i].total = happy + ok + sad
                    items[i].happy = happy
                    items[i].ok = ok
                    items[i].sad = sad
                    items[i].index = Math.round(((happy * 1 + ok * 0.5) / items[i].total) * 100)
                    totalV += items[i].total
                    if(okForFilter) newItems.push(items[i])
                }

                this.CollapsedBlocks = newCollapsedBlocks
                this.totalQuestions = totalQ
                this.reportItems = newItems;
                this.reportItemsTotalVotes = totalV
                this.sortReport()
            },

            refreshExtendedPlacements() {
                for (let i = 0; this.reportItems.length > i; i++) {
                    let block = this.reportItems[i]
                    for (let j = 0; block.questions.length > j; j++) {
                        let question = block.questions[j]
                        question.extended_placement = this.getExtendedPlacement(question)
                    }
                }
            },

            compareSubstrings(search, str) {
                return (search != "" && str != "") && (str.toLowerCase().includes(search.toLowerCase()))
            },

            // -- > DELETE
            deleteConfirm(item, question) {
                this.customModalSettings = {
                    siteUid: question.site_uid,
                    questionUID: question.uid,
                    sectionClass: 'full-width--btn',
                    title: this.translate('own_SureTODelete'),
                    message: this.translate('own_AllVotesWillDeleted'),
                    okButtonText: this.translate('own_DeleteQuestion'),
                    onOkHandler: this.deleteQuestion,
                    showCancelButton: true
                }
            },

            async deleteQuestion(obj) {
                try {
                    const response = await this.deleteQuestionAction({
                        questionId: obj.questionUID,
                        siteUid: obj.siteUid
                    })
                    if (response.success) {
                        this.customModalSettings = {
                            sectionClass: 'full-width--btn',
                            icon: 'ic_allow.svg',
                            title: this.translate('own_HasBeenDeleted'),
                            message: this.translate('own_DontForgetCreate')
                        }
                        logAnalyticsEvent(`analytics_question_delete_success`)
                        this.refreshReport();
                    }
                } catch (e) {
                    logError('analytics_question_delete_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message)
                }
            },

            doSomethingOnHide() {
                this.getReport(new Date(this.customDate.date_from).getTime(), new Date(this.customDate.date_to).getTime())
                this.showDateFrom = false;
                this.showDateTo = false;
            },

            doSomethingOnChangeFrom() {
                if (this.customDate.date_from) {
                    this.optionsTo.minDate = new Date(new Date(this.customDate.date_from).getTime())
                }
            },

            doSomethingOnChangeTo() {
                if (this.customDate.date_to) {
                    this.optionsFrom.maxDate = new Date(new Date(this.customDate.date_to).getTime())
                }
            },

            async onSuggestionsBtnClick() {
                logAnalyticsEvent('question_suggest_click')
                this.customModalSuggests = {
                    show: true,
                    onOkHandler: this.onSuggestionItemSelected,
                    onCancelHandler: this.onSuggestionDialogCanceled
                }
            },

            onSuggestionItemSelected(text) {
                logAnalyticsEvent('question_suggest_selected')
                this.questionActionSidebarSettings.questionItem.value = `${text}`
            },

            onSuggestionDialogCanceled() {
                logAnalyticsEvent('question_suggestion_canceled')
            },

            onColumnNameClick(type) {
                this.innerSorting.sortTypeFirst = type
                this.sortReport()
            },

            sortReport() {
                var type = this.innerSorting.sortTypeFirst
                if(type == this.innerSorting.sortColumn) {
                    this.innerSorting.sortDir *= -1
                }
                let reportBy = this.showReportByChosen.tag
                if (reportBy == 'by_sites' && type == 'place_name') {
                    type = 'text'
                } else if (reportBy == 'by_questions' && type == 'text') {
                    type = 'place_name'
                } else if (reportBy == 'by_locations' && type == 'optional') {
                    type = 'place_name'
                }
                this.innerSorting.sortColumn = type
                this.innerSorting.sortTypeFirst = type

                var sortLogic = this.getDefaultSortOrder(reportBy).filter(item => item !== type)
                sortLogic.splice(0, 0, type)
                this.innerSorting.sortLogic = sortLogic

                console.log(`this.innerSorting.sortLogic: ${this.innerSorting.sortLogic}`)
                let items = this.reportItems
                for (let i = 0; items.length > i; i++) {
                    items[i].questions.sort(dynamicSortMultiple.apply(this, [this.innerSorting.sortLogic,  this.innerSorting.sortDir]))
                }
                this.reportItems = items;
            },

            getDefaultSortOrder(reportBy) {
                var order = ['total_votes', 'happy', 'ok', 'sad', 'id']
                if (reportBy == 'by_sites') {
                    order = ['text', 'optional', 'total_votes', 'happy', 'ok', 'sad', 'id']
                } else if (reportBy == 'by_questions') {
                    order = ['place_name', 'optional', 'total_votes', 'happy', 'ok', 'sad', 'id']
                } else if (reportBy == 'by_locations') {
                    order = ['place_name', 'text', 'total_votes', 'happy', 'ok', 'sad', 'id']
                }
                return order
            },

            getExtendedPlacement(question) {
                let show_w3w = this.userInfo.setups.views.show_w3w && question.location
                let reportBy = this.showReportByChosen.tag
                let arr = []
                if (reportBy == 'by_sites') {
                    // placement | asset_id | w3w
                    if(question.placement) arr.push(question.placement)
                } else if ( reportBy == 'by_questions' ) {
                    // site | placement | asset_id | w3w
                    if(this.siteListDropdown.length > 1) arr.push(question.place_name)
                    if(question.placement) arr.push(question.placement)
                } else if (reportBy == 'by_locations') {
                    // site | asset_id | w3w
                    if(this.siteListDropdown.length > 1) arr.push(question.place_name)
                }
                if(question.asset_id) arr.push(question.asset_id)
                if(show_w3w) arr.push(question.location.w3w)
                let value = arr.join(' | ')
                if(show_w3w && value == question.location.w3w) {
                    value = this.translate('own_ExtPlacementEdit') + ' | ' + value
                }
                return value
            },

            onExtendedPlacementClick(question) {
                let routeData = this.$router.resolve({name: 'QuestionManageScreen', params: {questionId: question.uid}});
                window.open(routeData.href, '_blank');
            },

            shouldShowAnswer(question) {
                return (question.green == null || this.translate('own_Happy').toUpperCase() !== question.green.toUpperCase())
                    || (question.yellow == null || this.translate('own_SoSo').toUpperCase() !== question.yellow.toUpperCase())
                    || (question.red == null || this.translate('own_Sad').toUpperCase() !== question.red.toUpperCase())
            },
            routeToAirLeadDashboard() {
                 this.$router.push({name: 'AirLeadDashboard'})
            },
            routeToServiceLogsDashboard() {
                 this.$router.push({name: 'ServiceLogsDashboard'})
            },
            airLeadCheck() {
                if(this.isAirLeadEnabled && this.isUserOwner) {
                    return true
                } else if (this.isAirLeadEnabled && this.isUserOrgManager) {
                    return true
                } else if (this.isUserAirLeadManager) {
                    return true
                } else {
                    return false
                }
            },
            goToSecondLevelDetails(item, question) {
              this.$router.push({name: 'dashboardSecondLevelDetailsQuestions', params: {uid: question.site_uid, orgUid: this.getOrgUid, questionUid: question.uid}})
            },
			goToServiceLogScreen(item, question) {
				this.$router.push({name: 'dashboardServiceLogQuestions', params: {uid: question.site_uid, orgUid: this.getOrgUid, questionUid: question.uid}})
			},
            checkIfOwnerHaveOriginalCredential() {
              return localStorage.getItem('originalCredentials') !== null
            },
            needShowServiceLogsBtn() {
                if(this.hasServiceLogs && this.isUserOwner) {
                    return true
                } else if (this.hasServiceLogs && this.isUserOrgManager) {
                    return true
                } else if (this.isServiceLogManager) {
                    return true
                } else {
                    return false
                }
            },
            logAction(action) {
                try {
                    this.logUserAction({ action: action})
                } catch (e) {}
            },
        },
    }

</script>

<style>

    .myPopover {
        position: fixed;
        will-change: transform;
        top: 0px;
        left: 0px;
    }
    .optional {
        overflow: hidden;
        word-break: break-all;
    }
    .button-group__wrapper {
      display: flex;
      flex-direction: row-reverse;
    }
    .button-group.analytic {
        width: 100%;
        justify-content: flex-end;
    }
    @media screen and (max-width: 1240px) {
      .button-group.analytic {
        justify-content: flex-start;
      }
    }

    .popover-target,
    .popover-target:hover,
    .popover-target:focus,
    .popover-target.btn-secondary:not(:disabled):not(.disabled):active,
    .popover-target:focus:hover {
        background: none;
        border: none;
        color: #212529;
        box-shadow: none;
    }

    .popover {
        min-width: 95vw;
    }

    .content-row_happy {
        margin-right: 10px;
    }


    @media screen and (min-width: 1000px) {
        .popover {
            min-width: 80vw;
        }
        .owner-filter__bottom .calendar-inline {
            margin-left: 0px;
        }
    }

    .dash {
        cursor: pointer;
    }

    .reset-chart-icon {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        margin-left: 5px;
        margin-bottom: 1px;
        vertical-align: middle;
        width: 22px;
        height: 22px;
        background: url('../../../assets/icons/ic_reset_chart.svg');
    }

    .chart-undo-icon {
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;
        margin-left: 0px;
        margin-bottom: 0px;
        vertical-align: middle;
        width: 22px;
        height: 22px;
        background: url('../../../assets/icons/ic_chart_undo.svg');
    }

    .chart-panel-right,
    .chart-panel-left {
        position: absolute;
        top: 5px;
    }

    .chart-panel-left {
        left: 10px;
    }

    .chart-panel-right {
        right: 10px;
    }

    .chart-popover {
        padding-top: 25px;
        border: 1px solid #a3a3a3;
    }

    .chart-popover .popover-header {
        display: none;
    }

    .chart-panel-left .chart-btn {
        margin-right: 5px;
        opacity: 0.4;
    }

    .chart-panel-left .chart-btn.active {
        opacity: 1;
        border: 1px solid #000;
        pointer-events: none;
    }

    .chart-close-icon {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        margin-left: 10px;
        width: 15px;
        height: 15px;
        background: url('../../../assets/icons/ic_close_white.svg');
        background-size: cover;
    }

    .col-title-list span {
        cursor: pointer;
        color: blue;
    }
    .sort-col-wrapper {
        display: flex;
        align-items: center;
    }
    .sort-col-wrapper.QR {
        display: flex;
        justify-content: flex-end;
        padding-right: 3px;
    }

    .QRSticker__image {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
    }
    .sort-col-wrapper img {
        width: 12px;
        height: 12px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .sort-col-wrapper span {
        color: #6D6D6D;
        font-size: 14px;
        line-height: 22px;
    }

    .col-title-underlined {
        text-decoration: underline;
    }

    .col-title-list span:hover {
        text-decoration: underline;
    }
    .createQuestion__text {
        color: white !important;
        font-family: 'Nunito';
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 18px;
    }
    .owner-filter__bottom .range-select {
        align-items: center;
    }
    .owner-filter__bottom .range {
        flex-direction: column;
        align-items: start;
    }
    .owner-filter__bottom .range-select .search_places {
        width: 170px;
    }
    .owner-filter__bottom .range-select__wrapper {
        display: flex;
    }
    .owner-filter__bottom .calendar-inline {
        width: 100%;
        margin-left: 15px;
    }
    .calendar-inline__wrapper {
        display: flex;
        margin-top: 20px;
        width: 100%;
        justify-content: space-between;
    }
    .smile-section.answers {
        flex-direction: column;
    }
    .rates-section.column {
        display: flex;
        flex-direction: column !important;
    }
    .smiley-count {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .question-answer {
        font-size: 12px;
        color: #575757;
        margin-top: 5px;
        text-align: center;
        width: 100%;
    }
    .question-answer-row {
        margin-top: 0;
        font-size: 14px;
        margin-left: 12px;
        align-self: center;
    }
    .rates-section ul li {
        background-color: #3F405C;
    }
    .rates-section .rates-item .info {
        color: white;
    }
    .rates-section .rates-item {
        padding: 8px 16px;
    }
    .rates-item__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
    }
    .comments-btn__wrapper {
        display: flex;
    }
    .comments-btn {
        flex-direction: row-reverse;
        border-radius: 0px;
    }
    .comments-btn img {
        margin-right: 0;
        margin-left: 9px;
    }
    .comments-btn-group.pointer {
        cursor: pointer;
    }
    .comments-btn-group .comments-btn b {
        text-align: start;
    }
    .comments-btn-group.hide {
        display: none;
    }
    .rates-section ul li {
        margin-right: 6px;
    }
    .custom-modal .modal-message {
        width: auto;
    }
    .order-banner{
        width: 100%;
        background: radial-gradient(66.67% 798.82% at 21.87% 87.98%, #43457A 0%, #3F405C 100%);
        border-radius: 6px 6px 0px 0px;
        position: fixed;
        z-index: 99999;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .order-banner.active {
        display: none;
    }
    .order-banner__wrapper {
        display: flex;
        align-items: center;
        padding-left: 24px;
        padding-right: 24px;
    }
    .order-banner__text {
        margin-top: 24px;
        padding-bottom: 20px;
    }
    .order-banner__title {
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF;
        padding-bottom: 8px;
    }
    .order-banner__subtitle {
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
    }
    .order-banner__image {
        margin-left: 40px;
        margin-right: 56px;
        max-width: 450px;
    }
    .order-banner__image img {
        background-size: cover;
    }
    .order-banner__btn {
        background: #FFBF00;
        box-shadow: 0px 2px 6px rgba(255, 191, 0, 0.72);
        border-radius: 6px;
        height: 48px;
        margin-right: 96px;
        cursor: pointer;
    }
    .order-banner__btn-text {
        padding: 12px 56px;
        white-space: nowrap;
    }
    .order-banner__cross {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }
    .order-link {
        color: white;
    }
    .order-link:hover {
        color: white;
        text-decoration: none !important;
    }
    .primaryButton__group {
        margin-left: 8px;
    }
    .owner-filter__bottom .range .dropdown-range {
        padding: 5px 16px 15px;
    }
    .additional_service {
        min-width: 120px !important;
    }






    /* .analytics-tab .md-field.md-invalid .md-error {
        left: auto;
        right: 0;
    } */
    @media screen and (max-width: 1500px ) {
        .order-banner__image img {
            display: none;
        }
        .order-banner__wrapper {
            width: 100%;
            justify-content: space-between;
        }
    }
    @media screen and (max-width: 1210px) {
        .rates-section ul li.comments-btn-group {
            width: 100%;
            margin-right: 15px;
        }
        .comments-btn__wrapper {
            justify-content: space-around;
            align-items: center;
            width: 100%;
        }
        .rates-item__wrapper {
            margin-left: 50px;
            font-size: 14px;
        }
        .primaryButton__group {
            margin-left: 0px;
        }
        .button-group {
            flex-direction: row;
        }
        .button-group__wrapper {
            flex-direction: row-reverse;
        }
        .orderButton {
            display: none;
        }
        .moreOption {
            display: none;
        }
        .owner-filter__bottom .calendar-inline {
            margin-top: 5px;
            margin-bottom: 15px;
        }
        .calendar-inline__wrapper {
            margin-top: 5px;
        }
        .owner-filter__bottom .range .dropdown-range {
            background: #f3f3f3;
            padding: 0px 0px 15px 0px;
            margin-right: 16px;
        }
        .owner-filter__bottom .range .range-select .dropdown-range:first-child {
            margin-right: 16px;
        }
        .search_places {
            background-color: #f3f3f3 !important;
        }
        .filter__wrapper {
            -webkit-transition:max-height 0.4s linear;
            -moz-transition:max-height 0.4s linear;
            transition:max-height 0.4s linear;
            width: 100%;
        }
        .owner-filter__bottom .range-select {
            flex-direction: row;
        }
        .owner-filter__bottom .range-select__wrapper {
            flex-direction: column;
            width: 100%;
        }
        .owner-filter__bottom .range-select .search_places {
            width: 100%;
        }
        .btn-group, .btn-group-vertical {
            width: 100% !important;
        }
    }

    @media screen and (max-width: 576px) {
        .order-banner__wrapper {
            flex-direction: column;
        }
        .owner-filter__bottom .button-group button {
            min-width: 165px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .order-banner__btn {
            margin-right: 0;
            margin-bottom: 28px;
        }
        .button-group {
            justify-content: space-between;
        }
    }
    @media screen and (max-width: 426px) {
        .info-text {
            display: none;
        }
        .button-group__wrapper {
            flex-direction: column-reverse;
        }
        .rates-item__wrapper {
            text-align: center;
            margin-left: 5px;
        }
        .comments-btn-group .comments-btn b {
            text-align: center;
        }
        .owner-filter__bottom .button-group button img {
            width: 17px;
        }
        .owner-filter__bottom .button-group button {
            padding: 11px;
        }
    }

    @media screen and (max-width: 376px) {
        .calendar-inline__wrapper {
            flex-direction: column;
        }
        .owner-filter__bottom .calendar-inline {
            width: auto;
        }
    }
    @media screen and (max-width: 322px) {
        .order-banner__cross {
            right: 5px;
            top: 5px
        }
        .rates-section .rates-item {
            padding: 8px 10px;
        }
        .owner-filter__bottom .button-group button {
            min-width: 134px;
        }
        button.primaryButton.reverse {
            margin-right: 0;
        }
        .owner-filter__bottom .range-select {
            flex-direction: column;
        }
        .owner-filter__bottom .range .dropdown-range {
            margin-right: 0px !important;
        }
    }
</style>
<style scoped>
    .search_places {
        background-color: #F7F7F7;
        margin-top: -5px;
        /*width: 170px;*/
    }
    .question-ext_placement {
        display: block;
       word-break: break-word;
    }
    .ext_placement {
        text-decoration: underline;
        cursor: pointer;
    }
    .content-image {
        white-space: break-spaces;
        overflow: hidden;
    }
    .button-group {
        display: flex;
    }
    .owner-filter__bottom .button-group button {
        margin-right: 10px;
    }
    .sub-items-show-more {
        margin-top: 12px;
        margin-left: 50%;
        transform: translateX(-50%);
        min-width: 200px;
    }

    @media screen and (max-width: 1000px) {
        .owner-filter__bottom .button-group button {
            height: auto;
        }
        button.primaryButton {
            margin-right: 0;
        }
    }
    @media screen and (max-width: 426px) {
        .owner-filter__bottom .button-group button {
            height: 50px;
            margin-right: 0;
        }

    }
</style>
